// Components==============
import {
  faCheck,
  faPen,
  faTimes,
  faTrash,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAlert } from 'hooks/useAlert';
import { useTranslate } from 'hooks/useTranslate';
import { MyPortfolioContext } from 'pages/Portfolio/MyPortfolios/MyPortfolio';
import React, { useContext, useState } from 'react';
import './Row.module.scss';
// =========================

type Props = {
  name: string;
  id: number;
};

export default function Row({ name, id }: Props) {
  const [editing, setEditing] = useState<boolean>(false);
  const [value, setValue] = useState<string>(name);

  const alert = useAlert();

  const {
    handleDeletePortfolio,
    handleEditPortfolioName,
    portfolios,
  } = useContext(MyPortfolioContext);

  const translate = useTranslate();

  function handleEdit() {
    const nameExists = portfolios?.map((p) => p?.name).includes(value);

    if (value === name) return setEditing(false);
    if (nameExists) return alert(translate('general.terms.name-exists'));

    setEditing(false);
    handleEditPortfolioName(value, id);
  }

  return (
    <div styleName={`row ${editing ? 'editing' : null}`}>
      {editing ? (
        <input
          value={value}
          onChange={(e) => {
            setValue(e.target.value);
          }}
          onKeyDown={(e) => e.key === 'Enter' && handleEdit()}
        />
      ) : (
        <p>{value}</p>
      )}
      <div styleName="icons">
        {editing ? (
          <>
            <FontAwesomeIcon
              icon={faTimes}
              onClick={() => {
                setEditing(false);
                setValue(name);
              }}
            />
            <FontAwesomeIcon onClick={handleEdit} icon={faCheck} />
          </>
        ) : (
          <>
            <FontAwesomeIcon
              onClick={() => {
                setEditing(!editing);
              }}
              icon={faPen}
            />
            <FontAwesomeIcon
              icon={faTrash}
              onClick={() => handleDeletePortfolio(id)}
            />
          </>
        )}
      </div>
    </div>
  );
}
